import './ticket_response_view.js.coffee'

Namespace 'Customer.Dashboard'

class Customer.Dashboard.InstagramMessageTicketResponseView extends Customer.Dashboard.TicketResponseView

  initialize: (@options = {}) ->
    super(@options)
    @currentSticker = null
    @delegateEvents()

  events: ->
    _.extend(
      {},
      Customer.Dashboard.TicketResponseView.prototype.events,
      'keyup #response': 'handleWriteResponse'
    )

  _onToggleStickers: =>
    @stickerIcon.toggleStickers()
    container = @$el[0].getBoundingClientRect()
    stickerContainer = $('.instagram-response-sticker-selector .sections')
    stickerContainer.offset({
      top: container.top - stickerContainer.outerHeight(),
      left: container.right - stickerContainer.outerWidth()
    })

  checkAction: (action) ->
    @$el.find(".btn_send_response[value=#{action}]").hasClass('active')

  _addAttachments: (formData) ->
    if @attachment
      _.each(@attachment.allFiles(), (file) ->
        formData.append('upload', JSON.stringify(file))
      )

  _renderAttachments: ->
    @attachment = new Customer.Ticket.InstagramResponseAttachmentView(
      @_$attachmentUploader(),
      @,
      @getInteractionToResponseSubtype()
    )
    @_renderStickerIcon()
    @listenTo @attachment, 'add:attachment', @onAttachmentLoading
    @listenTo @attachment, 'remove:attachment', @onAttachmentRemove
    @listenTo @attachment, 'upload:attachment', @onAttachmentDone
    @attachment.render()
    @_setAttachmentTooltip(@_addAttachmentTooltip())

  _renderStickerIcon: ->
    return if @stickerIcon

    @stickerIcon = new Customer.Ticket.InstagramResponseStickerIconView()
    @listenTo @stickerIcon, 'add:sticker', (name) => @addSticker(name)
    @$el.find('.add_sticker').append(@stickerIcon.render().el)
    @$el.find('.instagram-sticker-icon').click(@_onToggleStickers)

  _paramsToResponse: (response, options, privacy) ->
    params = super(response, options, privacy)
    if @currentSticker
      params.append('sticker', @currentSticker.getName())
    params

  hasSticker: =>
    @currentSticker

  addSticker: (sticker) ->
    @currentSticker = new Customer.Ticket.InstagramStickerResponseView(sticker)
    @listenTo @currentSticker, 'remove:sticker', @removeSticker
    @_responseTextArea().hide()
    sticker = @currentSticker.render().el
    sticker.title = @_cantAddAttachmentsOrStickersTranslation()
    @$el.prepend(sticker)
    @disableInteractions()

  removeSticker: ->
    @currentSticker = null
    @enableInteractions()

  disableInteractions: ->
    @attachment._disableAddAttachmenntButton()
    @stickerIcon._disableAddStickerButton()
    @$el.find('.add_emoji').addClass('grayed')
    @$el.find('.shorten_links').addClass('grayed')
    @$el.find('#add-signature').addClass('grayed')
    @_disableResponseTextArea()
    @changeToDisableTextTooltip()

  enableInteractions: ->
    @attachment._enableAddAttachmenntButton()
    @stickerIcon._enableAddStickerButton()
    @$el.find('.add_emoji').removeClass('grayed')
    @$el.find('.shorten_links').removeClass('grayed')
    @$el.find('#add-signature').removeClass('grayed')
    @_enableResponse()
    @_responseTextArea().show()
    @disableTextTooltip()

  disableTextTooltip: ->
    @$el.find('#response').removeAttr('title')
    @_setAttachmentTooltip(@_addAttachmentTooltip())

  changeToDisableTextTooltip: ->
    translation = @_cantAddAttachmentsOrStickersTranslation()
    @$el.find('#response')[0].title = translation
    @_$attachmentUploader()[0].title = translation

  _setAttachmentTooltip: (tooltip) ->
    @_$attachmentUploader()[0].title = tooltip

  canAddAttachments: -> true

  canSendPictures: -> true

  onAttachmentRemove: ->
    @onAttachmentDone()
    @enableInteractions()

  onAttachmentDone: ->
    if @attachment._hasInvalidSize()
      @_handleInvalidSizeError()
      @_enableResponse()
    else if @attachment._hasUnsupportedFile()
      @_handleUnsupportedFormatError()
      @_enableResponse()
    else
      super()
      @disableInteractions()

  handleWriteResponse: ->
    value = @_responseTextArea().val()
    if value.length > 0
      @attachment._disableAddAttachmenntButton()
      @stickerIcon?._disableAddStickerButton()
      @_setAttachmentTooltip(@_cantAddAttachmentsOrStickersTranslation())
    else
      @attachment._enableAddAttachmenntButton()
      @stickerIcon?._enableAddStickerButton()
      @_setAttachmentTooltip(@_addAttachmentTooltip())

  _handleInvalidSizeError: ->
    swal
      title: I18n.t('customer.dashboard.errors.instagram_invalid_file_size_title')
      type: 'error'
      text: I18n.t('customer.dashboard.errors.instagram_invalid_file_size_text')
    @attachment.clearAllAttachments()

  _handleUnsupportedFormatError: ->
    swal
      title: I18n.t('customer.dashboard.errors.instagram_invalid_format_title')
      type: 'error'
      text: I18n.t('customer.dashboard.errors.instagram_invalid_format_text')
    @attachment.clearAllAttachments()
    @attachment._enableAddAttachmenntButton()

  _handleResponseError: (response) ->
    if ['Invalid extension', 'Unsuported type'].includes(response.message)
      @_handleUnsupportedFormatError()
      @_enableResponse()
    else
      super(response)
    @_disableResponseTextArea() if @hasAttachment()

  hasEnoughData: (response) =>
    super(response) || @currentSticker

  _canReply: ->
    @_checkValidInstagramAPI() && super()

  _checkValidInstagramAPI: =>
    interactionId = @_interactionIdToRespondTo('private')
    socialContent = @ticket.getInteractionById(interactionId)
    if @_isOldInstagramOrigin(socialContent)
      swal
        title: I18n.t('customer.dashboard.errors.instagram_invalid_integration.title')
        text: I18n.t('customer.dashboard.errors.instagram_invalid_integration.text')
        type: 'error'
        showConfirmButton: false
      return false
    return true

  _isOldInstagramOrigin: (content) ->
    return true unless content
    return true unless content.getOrigin
    content.getOrigin() == Monitoring.Models.SocialContents.InstagramDMContent.ORIGIN

  _cantAddAttachmentsOrStickersTranslation: ->
    I18n.t(
      'customer.dashboard.conversations.details.response.instagram.' +
        'cant_add_attachment_or_sticker_with_reply_at_the_same_time'
    )

  _addAttachmentTooltip: ->
    I18n.t(
      'customer.dashboard.conversations.details.response.instagram.add_attachment_tooltip'
    )

  _$attachmentUploader: ->
    @$el.find('.attachment-uploader')
